<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="logsTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_POINTPOOLSTATISTICS',
        hidePage: true,
        formComponent: {
          list: { type: 'default', value: '/modules/statisticalIntegralPool/integralPoolStatistical' }
        },
        formInputsData: [
          { name: '结束时间', key: 'endTime', value: '', type: 'date' },
          { name: '机构',
            key: 'orgId',
            value: '',
            type: 'cascader',
            filterable: true,
            options: [],
            props: {
              children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', emitPath: false }}
        ],
        formButtonsData: [{ name: '导出',
          key: 'EXCEL',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/statisticalIntegralPool/integralPoolStatisticalImport',
          fileName: '积分池统计',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '物业公司', key: 'name', type: 'text' },
          { name: '累计发放总积分', key: 'integral', type: 'text' },
          { name: '累计消耗总积分', key: 'consumptionIntegral', type: 'text' },
          { name: '累计赠送总积分', key: 'giftIntegral', type: 'text' },
          { name: '累计剩余总积分', key: 'remainingIntegral', type: 'text' },
          { name: '结束时间', key: 'statisticalEndTime', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: true }
      }
    }
  },
  created() {
    this.orgTreeList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'DELETEALL') {
          this.$wtUtil.deleteConfirm(this, '确认清空？').then(() => {
            request({
              url: '/modules/logs/lopperClear',
              method: 'post'
            }).then(res => {
              if (res.code === '0') {
                this.$message({ message: '清空成功', type: 'success' })
                this.$refs.logsTableRef.requestList()
              }
            })
          })
        }
      }
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeAllListNoSite().then(res => {
        // this.$wtUtil.setSiteLevelKey(res.data)
        this.form.formInputsData[1].options = res.data.map(v => {
          delete v.childList
          return v
        })
      })
    }
  }
}
</script>
